import * as React from "react"
import {AutocompleteAjaxSeeker} from "@ui-seeker/core"

import {LabelCountry} from "@components"
import {BACKEND_APIS} from "@constants"
import {country, retailer} from "../@signals"


export default function UnmatchedNewProductsRetailerAutocomplete({filters={}, ...props}) {
    return <AutocompleteAjaxSeeker
        multiple
        urlAjax={`${BACKEND_APIS.UNMATCHED}/new-products/site`}
        filters={{ country: country.value, ...filters }}
        label="Retailers"
        placeholder="All Retailers"
        value={retailer.value}
        onChange={e => retailer.value = e.target.value}
        formatOptionLabel={({ label, country }) => <LabelCountry country={country} label={label} />}
        {...props}
    />
}